import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PrescriptionItem = function (_a) {
    var name = _a.name, description = _a.description, fonts = _a.fonts;
    return (_jsxs("div", { style: { marginBottom: 16 }, children: [_jsx("div", { style: {
                    fontSize: "".concat(fonts.medicineNameFontSize, "px"),
                    fontWeight: 700,
                    lineHeight: 1.25,
                    color: '#000',
                    fontFamily: 'Arial, Helvetica, sans-serif'
                }, children: name }), description ? (_jsx("div", { style: {
                    fontSize: "".concat(fonts.medicineDescriptionFontSize, "px"),
                    color: '#444',
                    lineHeight: 1.4,
                    marginTop: 4,
                    fontFamily: 'Arial, Helvetica, sans-serif'
                }, children: description })) : null] }));
};
